var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"nest"},[_c('router-link',{attrs:{"to":{ name: 'NestMembers', params: { nestId: _vm.nest._id }}}},[_c('h3',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.nest.name)+" ")])])],1),_c('button',{on:{"click":_vm.deleteNest}},[_vm._v(" 🗑️ Delete ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }